import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

const PrivateRoute = ({ allowedRoles, userRole }) => {
    const { accounts } = useMsal();

    // Check if user is logged in and If user's role is not allowed, redirect to unauthorized page or home
    if (accounts.length === 0 || !allowedRoles.includes(userRole)) {
        return <Navigate to="/" replace />;
    }
    
    return <Outlet />;
};

export default PrivateRoute;
